import { Button } from '@vadiun/react-components';
import React, { FunctionComponent, useState } from 'react';

type Props = {
  onMarkTravelCancelCheck: () => Promise<void>;
};

const MarkAsViewed: FunctionComponent<Props> = ({
  onMarkTravelCancelCheck
}) => {
  const [isLoadingCancelChecked, setIsLoadingCancelChecked] =
    useState<boolean>(false);

  const onMark = async () => {
    setIsLoadingCancelChecked(true);
    await onMarkTravelCancelCheck();
    setIsLoadingCancelChecked(false);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onMark}
      className="w-40"
      isLoading={isLoadingCancelChecked}
    >
      Marcar como vista
    </Button>
  );
};

export default MarkAsViewed;
